
















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    name:"AxSpinner",
    components: {},
})

export default class AxSpinner extends Vue {

  @Prop({ required: false }) public show: boolean;
}

